import { baseUrl } from '@/config/env';
import request from '@/router/axios';
import { parseParam } from '@/util/util';

export const findRedPacketDetail = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales/v1/redPacket/details?`+params,
        method: 'GET'
    })
}
export const downloadQrCodeLink = (id) => {
    let url=`${baseUrl}`+`/joins-sales/v1/redPacket/downloadExcelQrCodeLink/${id}`
    window.open(url);
}
export const downloadExcel = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales/v1/redPacket/downloadExcelByAgent?` + params,
        method: 'GET'
    })
}